import React from "react";

function MeetCareeist() {
  return <div>MeetCareeist</div>;
}

export default MeetCareeist;
